var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"half-circle-spinner"},[_c('div',{staticClass:"circle circle-1"}),_c('div',{staticClass:"circle circle-2"})])}]

export { render, staticRenderFns }